// extracted by mini-css-extract-plugin
export default {"mainContainer":"TypeBadge_mainContainer__jycn7"};